<template>
  <v-text-field
    v-model="model"
    :placeholder="placeholder"
    :label="label"
    :prepend-inner-icon="icon"
    :hide-details="hideDetails"
    :rules="allRules"
    filled
    v-bind="$attrs"
    v-on="$listeners"
  ></v-text-field>
</template>

<script>
import ModelManagementMixin from '@/mixins/ModelManagementMixin';

export default {
  name: 'InnTextField',
  mixins: [ModelManagementMixin],
  props: {
    label: String,
    placeholder: String,
    hideDetails: Boolean,
    rules: {
      type: Array,
      default: () => [],
    },
    icon: String,
    required: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    allRules() {
      const required = (v) => !!v || 'Esse campo é obrigatório';
      return this.required ? [...this.rules, required] : this.rules;
    },
  },
};
</script>

<style></style>
